import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb, Row, Button, OverlayTrigger, Tooltip, Col, Card } from 'react-bootstrap';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { SHOW_CLAIM_GROUP_TASKS, SHOW_CLAIM_GROUPS_SELECTOR } from '@rd-web-markets/market/dist/constants';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import NoClaimsPage from '@rd-web-markets/shared/dist/claim_group/NoClaimsPage';
import ClaimGroupMasterPageDashboard from '@rd-web-markets/shared/dist/dashboards/dashboards/ClaimGroupMasterPageDashboard';
import ClaimGroupSidebar from '@rd-web-markets/shared/dist/pages/setup/ClaimGroupSidebar';
import { ClaimState } from '@rd-web-markets/market/dist/claim';
import { getDashboardLink } from '@rd-web-markets/shared/dist/util/getDashboardLink';
const MarketClaimGroupMasterPage = _ref => {
  var _claimGroup$tasks;
  let {
    company,
    claimGroup,
    allClaimGroups,
    accountType,
    companyId,
    claimGroupId,
    markTaskComplete,
    updateClaimGroupTask,
    ClaimGroupNavigation
  } = _ref;
  const {
    t
  } = useTranslation();
  if (!company || !allClaimGroups.length) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimGroupSidebar, {
    claimGroup: claimGroup,
    company: company,
    claims: company.claims,
    accountType: accountType,
    highlightedMenuItem: "claim_overview"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ps-4 pe-4"
  }, /*#__PURE__*/React.createElement(BreadcrumbsPortal, null, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(accountType)
    }
  }, t('home')), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(accountType, "/companies/")
    }
  }, t('companies')), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    active: true
  }, company.name))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center mt-3 mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center",
    style: {
      height: '60px'
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary mb-0"
  }, claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.name), company.risk == 'high' && /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "right",
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, t('company_sic_code_is_high_risk'))
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      color: '#DCA90E'
    }
  }, "warning")))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3"
  }, (claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.claim_period) && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '1rem',
      color: '#374151',
      background: '#F3F4F6',
      borderRadius: '8px',
      padding: '10px 20px',
      fontWeight: 600,
      letterSpacing: '0.02em'
    }
  }, claimGroup.claim_period))), !claimGroup && /*#__PURE__*/React.createElement(NoClaimsPage, {
    company: company,
    accountType: accountType
  }), !!claimGroup && /*#__PURE__*/React.createElement(React.Fragment, null, !SHOW_CLAIM_GROUPS_SELECTOR && ClaimGroupNavigation && /*#__PURE__*/React.createElement(ClaimGroupNavigation, {
    claimGroups: allClaimGroups,
    claim_group_id: claimGroupId,
    accountType: accountType,
    company: company,
    claimGroupId: claimGroup.id
  }), /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end mb-1 mt-3"
  }), !!((_claimGroup$tasks = claimGroup.tasks) !== null && _claimGroup$tasks !== void 0 && _claimGroup$tasks.length) && SHOW_CLAIM_GROUP_TASKS && /*#__PURE__*/React.createElement(ClaimState, {
    tasks: claimGroup.tasks,
    markTaskComplete: markTaskComplete,
    updateClaimGroupTask: updateClaimGroupTask,
    claimGroup: claimGroup
  }), /*#__PURE__*/React.createElement(Card, {
    className: "mt-4 p-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "my-4"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary fw-bold mb-3"
  }, t('current_totals')), /*#__PURE__*/React.createElement(Row, {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted",
    style: {
      fontSize: '0.8rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }
  }, t('projects')), /*#__PURE__*/React.createElement("div", {
    className: "fw-bold",
    style: {
      fontSize: '1.6rem'
    }
  }, claimGroup.projects_count)), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted",
    style: {
      fontSize: '0.8rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }
  }, t('total_cost')), /*#__PURE__*/React.createElement("div", {
    className: "fw-bold",
    style: {
      fontSize: '1.6rem'
    }
  }, claimGroup.total_cost)), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted",
    style: {
      fontSize: '0.8rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }
  }, t('qualifying_expenditure')), /*#__PURE__*/React.createElement("div", {
    className: "fw-bold",
    style: {
      fontSize: '1.6rem'
    }
  }, claimGroup.total_rnd_amount)), /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    as: Link,
    to: getDashboardLink(company, accountType, claimGroup)
  }, t('dashboard'), /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 ms-1",
    style: {
      verticalAlign: 'middle'
    }
  }, "chevron_right"))))))), /*#__PURE__*/React.createElement(Card, {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ClaimGroupMasterPageDashboard, {
    companyId: companyId,
    claimGroupId: claimGroupId,
    className: "mt-5 mb-5"
  }))))));
};
export default MarketClaimGroupMasterPage;